import { DivisionLayout } from '../components/layout/DivisionLayout';

const divisionData = {
  divisionName: 'Precision Turning',
  accentColor: '#90b8d8',
  heroImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/ohgtbzvj_image.png',
  aboutText: [
    {
      text: '<strong>Catworth Precision Turning</strong> provides <strong>high-precision CNC machining services for the manufacture and refurbishment of critical components used in mining, industrial, and engineering applications</strong>. Our focus is on producing components to customer drawings with consistent accuracy, supporting both once-off parts and repeat production requirements.'
    },
    {
      text: 'Equipped with advanced turning centres and supported by experienced machinists, <strong>Catworth</strong> delivers reliable machining solutions across a range of materials, including <strong>carbon steels, stainless steels, and high-strength alloys</strong>. In addition to machining, we offer <strong>heat treatment and thermal spraying services</strong>, enabling component strengthening, wear resistance, and dimensional restoration for extended service life. With a strong emphasis on precision, quality control, and repeatability, we supply components suited to demanding operating environments.'
    }
  ],
  aboutImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/ak2k5jw9_image.png',
  galleryImages: [
    'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/lf9ym82i_image.png',
    'https://images.unsplash.com/photo-1759159091728-e2c87b9d9315?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1701448149957-b96dbd1926ff?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  capabilities: [
    { title: 'CNC Turning (Up to 5000mm Length × 650mm Diameter)', description: 'Precision machining of small to large components.' },
    { title: 'Multi-Axis Machining', description: 'Efficient processing of complex geometries.' },
    { title: 'Tight Tolerance Manufacturing', description: 'Accurate and repeatable machining to specification.' },
    { title: 'Heat Treatment Processes', description: 'Material strengthening and performance enhancement.' },
    { title: 'Thermal Spraying & Component Reconditioning', description: 'Wear-resistant coating and dimensional build-up of components.' },
    { title: 'Material Versatility', description: 'Processing of carbon steel, stainless steel, and high-strength alloys.' },
    { title: 'Quality Control and Inspection', description: 'In-house inspection to ensure accuracy and consistency.' },
  ],
};

export const PrecisionTurning = () => {
  return <DivisionLayout {...divisionData} />;
};

export default PrecisionTurning;
